import { render, staticRenderFns } from "./credit_gatewayamb.vue?vue&type=template&id=128362d8&scoped=true&"
import script from "./credit_gatewayamb.vue?vue&type=script&lang=js&"
export * from "./credit_gatewayamb.vue?vue&type=script&lang=js&"
import style0 from "./credit_gatewayamb.vue?vue&type=style&index=0&id=128362d8&prod&scoped=true&lang=css&"
import style1 from "./credit_gatewayamb.vue?vue&type=style&index=1&id=128362d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128362d8",
  null
  
)

export default component.exports